import { useQuery } from '@tanstack/react-query';
import type { Recommendations } from 'shared';
import { api } from '@/lib/api';
import { useAuthStore } from '@/stores/auth';

/**
 * GET /api/participants/{id}/recommendations — activities suggested to the
 * current participant. Answers `enabled: false` while the server has
 * suggestions switched off.
 */
export function useMyRecommendations(participantId: number | undefined) {
  const { isAuthenticated, kind } = useAuthStore();
  const enabled =
    isAuthenticated && kind === 'participant' && typeof participantId === 'number' && participantId > 0;

  return useQuery({
    queryKey: ['recommendations', 'mine', participantId ?? 0],
    queryFn: () => api.get<Recommendations>(`/api/participants/${participantId}/recommendations`),
    enabled,
    staleTime: 5 * 60_000,
  });
}
